import styled from 'styled-components'

export const Developers = styled.div`
  background: #101010;
  padding: 80px 0 80px;
  overflow: hidden;

  .title {
    font-size: 26px;
    font-weight: 900;
    color: #fff;
    text-align: left;
    margin-bottom: 20px;
    position: relative;

    .gatsby-image-wrapper {
      position: absolute !important;
      left: -37px;
      top: 13px;
    }
  }

  .grid {
    display: flex;

    .contains {
      padding-right: 50px;
      flex: 3;
      
      .text {
        margin-bottom: 20px;

        p {
          color: #d1d1d1;
          margin-bottom: 10px;
        }
      }
    }

    .code {
      flex: 5;
    }

    .coming-grid {
      display: flex;
      margin-top: 50px;

      > div {
        flex: 1;
      }

      .item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        &__icon {
          margin-bottom: 10px;

          svg {
            width: 60px;
            height: 60px;

            &.sdk {
              fill: #fff;
              margin-left: -7px;

              * {
                fill: #fff !important;
              }
            }
          }
        }

        &__name {
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          margin-bottom: 5px;
        }

        &__description {
          color: #d1d1d1;
          padding-right: 15px;
        }

        &__alert {
          font-size: 10px;
          text-transform: uppercase;
          background: #3e3e3e;
          color: #fff;
          padding: 2px 5px;
          border-radius: 4px;
          margin-bottom: 5px;
        }
      }
    }
  }

  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }

  .clearfix { display: inline-block; }
  .clearfix { height: 1%; }
  .clearfix { display: block; }

  .editor_contact {
    position: absolute;
    background: rgba(20,20,20,0.7);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    opacity: 0;
    transition: all 0.4s;
    flex-direction: column;

    &__text {
      font-size: 20px;
      margin-bottom: 30px;
      width: 90%;
      max-width: 300px;
      color: #fff;
      text-align: center;
    }
  }

  .editor_window {
    position: relative;
    background: #262626;
    width: 100%;
    height: 35rem;
    margin: 1rem auto;
    border-radius: .25rem;
    overflow: hidden;

    &:hover {
      .editor_contact {
        opacity: 1;
      }
    }
  }

  .editor_header {
    position: absolute;
    background: #f7f7f7;
    top: 0;
    left: 0;
    right: 0;
    height: 25px;
  }

  .editor_buttons {
    margin: 4px;
  }

  .editor_button {
    width: .75rem;
    height: .75rem;
    border-radius: 100%;
    margin: .2rem;
    float: left;
  }

  .editor_content {
    position: absolute;
    background: #1e1e1e;
    top: 25px;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .editor_main {
    position: absolute;
    background: #2d2d2d;
    top: 2rem;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 2rem;
    overflow-x: scroll;

    .tabCustom {
      width: 30px;
      display: block;
      height: 10px;
      float: left;
    }

    pre.language-js {
      padding: 0 !important;
      margin: 0 !important;
    }

    * {
      font-size: 12px !important;
    }
  }

  .editor_tab {
    position: absolute;
    background: #2d2d2d;
    top: 0;
    left: 2rem;
    width: 10rem;
    height: 3.5rem;
  }

  .editor_line {
    height: 1.25rem;
    border-radius: .25rem;
    margin: .25rem;
    float: left;
  }

  .pink { background: #cd6667; }
  .light-green { background: #76c967; }
  .green { background: #babc6c; }
  .blue { background: #85b7ae; }
  .yellow { background: #dedc61; }
  .orange { background: #ebbf74; }
  .violet { background: #b498be; }
  .gray { background: #c2c4c3; }
  .small { width: 2rem; }
  .short { width: 5rem; }
  .medium { width: 8rem; }
  .mid-large { width: 10.5rem; }
  .large { width: 13.5rem; }
  .huge { width: 15.5rem; }
  .mega { width: 18rem; }

  @media screen and (max-width: 1000px) {
    padding: 50px 20px;

    .grid {
      flex-direction: column;

      .coming-grid {
        flex-direction: column;

        > div {
          margin-bottom: 40px;
        }
      }
    }
  }
`